import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "currentColor",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M75 5V0H65v5H35V0H25v5H0v95h100V5zM25 15v5h10v-5h30v5h10v-5h15v15H10V15zM10 90V40h80v50z" }, null, -1),
    _createElementVNode("path", { d: "M45 50h35v10H45zM45 70h35v10H45zM20 50h10v30H20z" }, null, -1)
  ]))]))
}
export default { render: render }